import script from "./DocListsMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocListsMenu.vue?vue&type=script&setup=true&lang=ts"

import "./DocListsMenu.vue?vue&type=style&index=0&id=ed9a19d0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed9a19d0"]])

export default __exports__